/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import SpinnerImage from './SpinnerImage';

export interface IProgressAnimationProps {
    status?: string;
}

export default class ProgressAnimation extends React.Component<IProgressAnimationProps, {}> {
    render() {
        return (
            <div className="apmui-progress-animation">
                {this.props.status ? <p className="apmui-progress-animation--message">{this.props.status}</p> : null}
                <div className="apmui-progress-animation--spinner">
                    <SpinnerImage />
                </div>
            </div>
        );
    }
}
